import React from "react";
import PredictionPage from "../../components/PredictionPage";

function NZDUSD() {
  return (
    <PredictionPage
      title="NZDUSD"
      content="This is the NZDUSD AI Trading Predictions page."
      canonical="/forex-majors/nzdusd-ai-trading-predictions"
      categoryKey="nav.forexMajors"
      categoryPath="/forex-majors"
      symbol="NZDUSD"
    />
  );
}

export default NZDUSD;
